import React from 'react';
import { useFela } from '../../..';
import { ViewProps } from './ViewProps';

const containerStyle = ({
  theme,
  align,
  noPadding,
}: {
  theme: any;
  align: string;
  noPadding: boolean;
}) => ({
  width: '100%',
  // TODO: Add support for 1800px content width when available in theme.
  // maxWidth: size === 'xl' ? theme.dimension.contentSize.xl.px : theme.dimension.contentSize.l.px,
  maxWidth: theme.dimension.contentSize.l.px,
  margin: '0 auto',
  extend: [
    {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
    {
      condition: align === 'left',
      style: { justifyContent: 'flex-start' },
    },
    {
      condition: align === 'right',
      style: { justifyContent: 'flex-end' },
    },
    {
      condition: align === 'center',
      style: { justifyContent: 'space-around' },
    },
    {
      condition: noPadding === false,
      style: {
        padding: `0 ${theme.dimension.spacing.s.rem}`,
        [theme.breakpoints.horizontal.m.mediaQuery]: {
          padding: `0 ${theme.dimension.spacing.xl.rem}`,
        },
        [theme.breakpoints.horizontal.l.mediaQuery]: {
          padding: `0 ${theme.dimension.spacing.m.rem}`,
        },
        [`@media (min-width: calc(${theme.dimension.contentSize.l.px} + 80px))`]:
          {
            padding: '0',
          },
      },
    },
  ],
});

const innerContainerStyle = ({
  theme,
  size,
}: {
  theme: any;
  size: string;
}) => ({
  width: '100%',
  maxWidth: size ? theme.dimension.contentSize[size].px : 'auto',
});

const View = ({
  dmId = 'dm-view',
  size = 'l',
  align = 'center',
  noPadding = false,
  children,
}: ViewProps) => {
  const { css } = useFela({ size, align, noPadding });
  return (
    <div
      id={dmId}
      data-designsystem
      data-dmid={dmId}
      className={css(containerStyle)}>
      <div className={css(innerContainerStyle)}>{children}</div>
    </div>
  );
};

export default View;
